import React, { useContext } from 'react';
import { Checkbox, Row, Col } from 'antd';
import { ViewDocument } from '../../../../components';
import { Context } from '../../../../defaults';


import './index.css';

const Question1 = ({ data, setData }) => {
    const { dictionary, language, setLoading } = useContext(Context);

    const radioStyle = {
        border: '1px solid #d9d9d9',
        display: 'block',
        width: '100%',
        padding: '20px',
        marginTop: '20px'
    };

    const onChange = (i, id) => {
        const copy = [...data.answerVariants];
        copy[i].isRight = copy[i].isRight === 1 ? 0 : 1;
        setData({ ...data, answerVariants: [...copy] });
    }

    return (
        <div>

            {
                data.answerVariants.map((el, i) => {
                    return <div style={radioStyle} key={`answer${el.id}`}>
                        <Row gutter={16}>
                            <Col span={2}>
                                <Checkbox value={el.id} checked={el.isRight === 1} onChange={() => onChange(i, el.id)} />
                            </Col>
                            <Col span={22}>
                                {
                                    el.answerText &&
                                    <p>{el.answerText}</p>
                                }
                                {
                                    el.files && el.files.length > 0 &&
                                    <ViewDocument files={el.files} />
                                }
                                {
                                    el.answerHtml &&
                                    <p style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: el.answerHtml }} />
                                }
                            </Col>
                        </Row>
                    </div>
                })
            }
        </div>

    );
}

export default Question1;